import { call, put } from 'redux-saga/effects';
import {
  refreshAuthTokenSuccess,
  refreshAuthTokenFailure,
  refreshAuthTokenFailureGeneric,
  loadAuthStateSuccess,
  loadAuthStateFailure,
  updateAuthStateSuccess
} from './actions';
import { RefreshAuthTokenService } from '../../../services/Auth';
import { CookiesKey } from '../../../services/Auth/enums';
import {
  IAuthState,
  IRefreshAuthToken,
  RENEW_TOKEN_INTERVAL_MILLISECONDS
} from './types';
import { isTokenExpired } from '../../../utils/tokenUtil';

function* refreshAuthTokenSaga() {
  const refreshAuthTokenService = new RefreshAuthTokenService();
  try {
    const tokenExpiresCurrent =
      refreshAuthTokenService.getValueCookie(
        CookiesKey.AUTHORIZATION_TOKEN_EXPIRATION
      ) || '';

    if (tokenExpiresCurrent == undefined || tokenExpiresCurrent == '') {
      yield call(updateAuthorizationToken);
    }
    yield call(updateAuthorizationToken);
    const tokenExpired = isTokenExpired(parseInt(tokenExpiresCurrent, 10));

    if (tokenExpired) {
      yield call(updateAuthorizationToken);
    }
  } catch (error) {
    if (error instanceof Error) {
      yield put(refreshAuthTokenFailure(error));
    } else {
      yield put(refreshAuthTokenFailureGeneric());
    }
  }
}

function* updateAuthorizationToken() {
  const refreshAuthTokenService = new RefreshAuthTokenService();

  const response: IRefreshAuthToken = yield call(
    refreshAuthTokenService.refreshAuthToken.bind(refreshAuthTokenService)
  );

  const azureDateTimeExpiration =
    new Date().getTime() + RENEW_TOKEN_INTERVAL_MILLISECONDS;

  RefreshAuthTokenService.setAuthorizationToken(response.access_token);
  RefreshAuthTokenService.setAuthorizationTokenExpiration(
    azureDateTimeExpiration.toString()
  );

  yield put(
    refreshAuthTokenSuccess(
      response.access_token,
      response.expires_in,
      azureDateTimeExpiration
    )
  );
  yield put(
    updateAuthStateSuccess(
      response.access_token,
      Number(response.expires_in),
      azureDateTimeExpiration
    )
  );
}

function* loadAuthSateSaga() {
  const refreshAuthTokenService = new RefreshAuthTokenService();
  try {
    const azureToken = refreshAuthTokenService.getValueCookie(
      CookiesKey.AUTHORIZATION_TOKEN
    ) as string;
    const azureDateTimeExpiration = refreshAuthTokenService.getValueCookie(
      CookiesKey.AUTHORIZATION_TOKEN_EXPIRATION
    ) as string;
    const azureExpireIn = 0;

    window.localStorage.setItem('azureToken', azureToken);
    window.localStorage.setItem('azureExpireIn', azureExpireIn.toString());
    window.localStorage.setItem(
      'azureDateTimeExpiration',
      azureDateTimeExpiration.toString()
    );

    const newAzureToken: IAuthState = {
      azureToken: azureToken,
      azureExpireIn: azureExpireIn,
      azureDateTimeExpiration: Number(azureDateTimeExpiration)
    };

    yield put(loadAuthStateSuccess(newAzureToken));
  } catch (error) {
    yield put(loadAuthStateFailure(error));
  }
}

export { refreshAuthTokenSaga, loadAuthSateSaga };
